import { useLazyQuery, useQuery } from "@apollo/client/react"; import { Box, Grid } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import ReclamoField from './components/searchFields/ReclamoField';
import UsuarioField from './components/searchFields/UsuarioField';
import moment from 'moment';

import { adaptDelegacionArray } from '../../../../adapters/delegacionAdapter';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_ALL_FUENTES } from '../../../../data/graphQL/queries/Capas/getAllFuentes';
import { GET_ALL_AREAS_CAPA } from '../../../../data/graphQL/queries/Reclamos/getAllAreasCapa';

const storageId = sessionStorage.getItem('idUsuario');
const nombreUsuarioCompleto = `${sessionStorage.getItem('nombre')} ${sessionStorage.getItem('apellido')}`;

export default function TabIngreso({
  idCapa,
  isNew,
  allowedWrite,
  etapaCreador,
  onChange,
  capaFormData,
  delegacionCargada
}) {
  const [delegaciones, setDelegaciones] = useState([]);
  const [fuentes, setFuentes] = useState([]);
  const [areas, setAreas] = useState([]);

  const [getDelegaciones, { data: dataDelegaciones, loading: loadingDelegaciones }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones || loadingDelegaciones) return;
    setDelegaciones(adaptDelegacionArray(dataDelegaciones));
  }, [dataDelegaciones]);

  const { data: dataFuentes } = useQuery(GET_ALL_FUENTES);

  useEffect(() => {
    if (!dataFuentes) return;
    const fuentes = dataFuentes?.allFuenteCapa?.map((fuente) => ({ id: fuente.idFuenteCapa, displayName: fuente.descripcion }));
    setFuentes(fuentes);
  }, [dataFuentes]);

  const { data: dataAreasCapa } = useQuery(GET_ALL_AREAS_CAPA);

  useEffect(() => {
    if (!dataAreasCapa) return;
    const areas = dataAreasCapa?.allAreasCapa?.map((area) => ({ id: area.idAreaCapa, displayName: area.descripcion }));
    setAreas(areas);
  }, [dataAreasCapa]);

  useEffect(() => {
    if (!etapaCreador) {
      setDelegaciones([delegacionCargada]);
    } else {
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId, 10) } });
    }
  }, [etapaCreador]);

  const updatedInputs = useMemo(() => {
    return structuredClone(inputs).map((input) => {
      switch (input.name) {
        case 'idDelegacion':
          input.options = delegaciones.filter((x) => x.displayName !== 'TODAS');
          break;
        case 'idFuente':
          input.options = fuentes;
          break;
        case 'idArea':
          input.options = areas;
          break;
        default:
          break;
      }
      if (!allowedWrite) {
        input.disabled = true;
      }
      return input;
    });
  }, [
    allowedWrite,
    delegaciones,
    fuentes,
    capaFormData]
  );

  useEffect(() => {
    if (isNew) {
      const fechaAltaAux = moment().format("yyyy-MM-DD");
      handleInputChange('fechaApertura', fechaAltaAux);
      handleInputChange('idUsuarioCreador', parseInt(storageId));
      handleInputChange('usuarioCreador', nombreUsuarioCompleto);
    }
  }, [idCapa, isNew]);

  const handleInputChange = useCallback((fieldName, value) => {
    if (fieldName === 'idDelegacion') {
      onChange({
        ...capaFormData?.stage1,
        idGestionReclamo: null,
        idResponsableAccion: null,
        [fieldName]: value
      });
    } else if (fieldName === 'idFuente') {
      onChange({
        ...capaFormData?.stage1,
        idGestionReclamo: null,
        [fieldName]: value
      });
    } else {
      onChange({
        [fieldName]: value
      });
    }
  }, [onChange]);

  return (
    <div>
      <Grid container spacing={2}>
        {updatedInputs.
          filter((input) => !input.positionFinal).
          map((input, index) =>
            <Grid key={`input-${input.name}-index-${index}`} size={{ xs: input.col }}>
              {input.name == 'reclamo' ?
                <ReclamoField
                  onChange={handleInputChange}
                  idGestionReclamo={capaFormData?.stage1?.idGestionReclamo}
                  tipoReclamo={capaFormData?.stage1?.idFuente}
                  disabled={!capaFormData?.stage1?.idFuente || capaFormData?.stage1?.idFuente !== 1 && capaFormData?.stage1?.idFuente !== 4 || !allowedWrite}
                  idDelegacion={capaFormData?.stage1?.idDelegacion} /> :

                input.name == 'usuarioResponsable' ?
                  <UsuarioField
                    onChange={handleInputChange}
                    idResponsableAccion={capaFormData?.stage1?.idResponsableAccion}
                    disabled={!capaFormData?.stage1?.idDelegacion || !allowedWrite}
                    idDelegacion={capaFormData?.stage1?.idDelegacion} /> :

                  <RenderInputByTypeMobile
                    key={`input-${input.name}-index-${index}`}
                    input={input}
                    handleChange={handleInputChange}
                    value={capaFormData?.stage1[input.name]} />
              }
            </Grid>
          )}
        <Grid size={{ xs: 6 }} />
        {updatedInputs.
          filter((input) => input.positionFinal).
          map((input, index) =>
            <Grid key={`input-${input.name}-index-${index}`} size={{ xs: 12, md: 6 }}>
              <RenderInputByTypeMobile
                key={`input-${input.name}-index-${index}`}
                input={input}
                handleChange={handleInputChange}
                value={capaFormData?.stage1[input.name]} />

            </Grid>
          )}
      </Grid>
    </div>);

}

const inputs = [
  //row
  {
    name: 'fechaApertura',
    displayName: 'Fecha apertura',
    type: 'date',
    disabled: true,
    col: 2
  },
  {
    name: 'idDelegacion',
    displayName: 'Delegación',
    type: 'select',
    options: [],
    required: true,
    col: 4
  },
  {
    name: 'idFuente',
    displayName: 'Fuente',
    type: 'select',
    options: [],
    required: true,
    col: 3
  },
  {
    name: 'space',
    type: 'item',
    hidden: true,
    col: 3
  },
  //row
  {
    name: 'reclamo',
    type: 'item',
    hidden: true,
    disabled: false,
    col: 3.5
  },
  {
    name: 'usuarioCreador',
    displayName: 'Usuario',
    type: 'string',
    disabled: true,
    col: 4
  },
  {
    name: 'idArea',
    displayName: 'Area',
    type: 'select',
    options: [],
    required: true,
    col: 4
  },
  {
    name: 'descripcion',
    displayName: 'Descripción',
    type: 'long_string',
    required: true,
    disabled: false,
    col: 12
  },
  {
    name: 'causa',
    displayName: 'Análisis Causa',
    type: 'long_string',
    disabled: false,
    col: 12
  },
  {
    name: 'accion',
    displayName: 'Acción',
    type: 'long_string',
    disabled: false,
    required: true,
    col: 12
  },
  {
    name: 'fechaAccion',
    displayName: 'Fecha acción',
    type: 'date',
    required: true,
    col: 3
  },
  {
    name: 'usuarioResponsable',
    type: 'item',
    hidden: true,
    disabled: false,
    required: true,
    col: 4
  },
  {
    name: 'responsableAccion',
    type: 'item',
    hidden: true
  },
  {
    name: 'observacion',
    displayName: 'Observación',
    type: 'long_string',
    disabled: false,
    col: 12
  }];